import React from "react";

/**
 * Joins a list of strings into a sentence, adds "and" between the last two items if needed.
 *
 * @param list Strings we want to join
 * @param sep Separator between items
 * @returns Formatted list as a sentence
 */
export const joinListVerbose = (list: string[], sep = ', '): string =>
  list.length < 2
    ? list.join('') // If there's only one item, return it as is
    : `${list.slice(0, -1).join(sep)} and ${list.at(-1)}`;


/**
 * Returns a span with the symbols joined by commas, "and" and underlined.
 * @param symbols Gene symbols
 * @param sep Separator between symbols
 */
export const verboseSymbols = (symbols: string[], sep = ', ') =>
  <span className="text-decoration-underline">{joinListVerbose(symbols, sep)}</span>